/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The SiteReferrer model module.
 * @module model/SiteReferrer
 * @version 1.0.0
 */
export default class SiteReferrer {
  /**
   * Constructs a new <code>SiteReferrer</code>.
   * @alias module:model/SiteReferrer
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>SiteReferrer</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SiteReferrer} obj Optional instance to populate.
   * @return {module:model/SiteReferrer} The populated <code>SiteReferrer</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SiteReferrer()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
      if (data.hasOwnProperty('available_types')) {
        obj['available_types'] = ApiClient.convertToType(data['available_types'], ['String'])
      }
      if (data.hasOwnProperty('notations')) {
        obj['notations'] = ApiClient.convertToType(data['notations'], ['String'])
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} name
   */
  name = undefined
  /**
   * @member {Array.<String>} available_types
   */
  available_types = undefined
  /**
   * @member {Array.<String>} notations
   */
  notations = undefined
}
